module.exports = __webpack_public_path__ + "static/media/Milex Inflatoball Pessary Instructions for Use@2x.602ea28c.jpg";